import React from 'react';
import classNames from 'classnames';
import MsgConfigSection from '../msg-config-section';
import { MessageConfigItem } from '../../../../interfaces';
import { platformIntl } from '../../../../../../constants';

interface SiteMsgConfigProps {
    className?: string;
    config?: MessageConfigItem;
}

/**
 * 站内消息渠道配置
 * 就是打开消息中心能看到的消息
 */
const SiteMsgConfig: React.FC<SiteMsgConfigProps> = (props) => {
    const { className, config } = props;

    return (
        <MsgConfigSection
            className={classNames('fx-site-msg-config', className)}
            checkProps={{
                checked: config?.enable ?? false,
                text: platformIntl.get('msg.system.notification'),
                disabled: true
            }}
            receiverProps={{
                receivers: config?.target,
                editable: false
            }}
            messageChannel="site"
        />
    );
};

export default SiteMsgConfig;
